import styled, { css } from 'styled-components';
import { Breakpoint } from 'src/utils/theme';

export const DisplayNone = styled.div<{
  $breakpoint: Breakpoint;
  $reverse?: true;
}>(
  ({ theme, $breakpoint, $reverse }) => css`
    ${
      $reverse
        ? css`
            @media (max-width: calc(${theme.sz[$breakpoint]} - 1px)) {
              display: none;
            }
          `
        : css`
            @media (min-width: ${theme.sz[$breakpoint]}) {
              display: none;
            }
          `
    }
  `,
);
